import React, { useState, useEffect } from "react";
import { useLocation } from "react-router-dom";
import "./side-bar.scss";
import CloseIcon from "@mui/icons-material/Close";
import { SidebarProps, MenuItem } from "./types/side-bar";
import hamburgerIcon from "../../../assets/icons/hamburger.svg";
import { Nav, NavItem } from "reactstrap";
import { NavLink, useNavigate } from "react-router-dom";
import { AlertComponent } from "../../../common/components";
import SubMenuSideBar from "./sub-menu";
import MemorialGoLogo from "../../../assets/media/side-bar-memo-go-logo.svg";
import { routes } from "../../../constants/routes";
import { useDispatch, useSelector } from "react-redux";

interface AlertMessage {
  open: boolean;
  message?: string;
  type?: "success" | "error" | "info" | "warning";
  onClose?: () => void;
}

const Sidebar: React.FC<SidebarProps> = ({ menuItems, footerItems }) => {
  const [alertMessage, setAlertMessage] = useState<AlertMessage>({
    open: false,
    message: "",
    type: "success",
  });
  const [collapsed, setCollapsed] = useState<{
    isOpen: boolean;
    activePath: string;
  }>({
    isOpen: false,
    activePath: "",
  });
  const [activeNavbar, setActiveNavbar] = useState({});

  // New state for auto-open and selection
  const location = useLocation();
  const [openDropdown, setOpenDropdown] = useState<string | null>(null);
  const [selectedPath, setSelectedPath] = useState<string>(
    routes.ADMIN_MANAGEMENT,
  );
  const dispatch = useDispatch();
  const showLeadIndicator = useSelector(
    (state: any) => state.lead.providerLeadIndicator,
  );

  const navigate = useNavigate();

  useEffect(() => {
    let found = false;
    menuItems.forEach((item) => {
      if (item.subMenu) {
        item.subMenu.forEach((sub) => {
          if (sub.path === location.pathname) {
            setOpenDropdown(item.label);
            setSelectedPath(sub.path);
            setCollapsed({ isOpen: true, activePath: item.label });
            found = true;
          }
        });
      }
      if (!found && item.path === location.pathname) {
        setOpenDropdown(null);
        setSelectedPath(item.path);
        //closing any open dropdowns
        setCollapsed({ isOpen: false, activePath: item.label });
        found = true;
      }
    });

    if (!found && location.pathname === routes.PROVIDER_PROFILE) {
      setOpenDropdown(null);
      setSelectedPath("");
      setCollapsed({ isOpen: false, activePath: "" });
    }
  }, [location.pathname, menuItems]);

  const toggleCollapse = (label: string) => {
    setCollapsed((prev) => ({
      isOpen: prev.activePath === label ? !prev.isOpen : true,
      activePath: label,
    }));
    setOpenDropdown(label);
  };

  const handleIfNoPath = (path: string) => {
    if (!path) {
      // Handle no path case
    }
  };

  const handleMenuClick = (item: MenuItem) => {
    if (item.subMenu) {
      toggleCollapse(item.label);
    } else {
      if (
        selectedPath === item.path &&
        selectedPath === routes.PROVIDER_LEADS
      ) {
        dispatch({
          type: "LEAD:REFRESH_PROVIDER_LEAD_PAGE",
          payload: { value: true },
        });
        dispatch({
          type: "LEAD:SET_PROVIDER_LEAD_INDICATOR",
          payload: { value: false },
        });
      }
      handleIfNoPath(item.path);
      setSelectedPath(item.path);
      navigate(item.path);
    }
  };

  const setIsSidebarClick = () => {};
  const setClickedActiveItem = () => {};

  return (
    <>
      <div className="sidebar-container">
        <div className="sidebar">
          <div className="sidebar-menu-items">
            {/* <div className="hamburger-icon" onClick={() => setCollapsed({ isOpen: !collapsed.isOpen, activePath: "" })}>
              <img src={hamburgerIcon} alt="hamburger" />
            </div> */}
            <div className="provider-logo-section">
              <img
                src={MemorialGoLogo}
                alt="Memorial Go Logo"
                className="sidebar-logo"
              />
              {/* Admin Portal Button div */}
              <div className="admin-portal-button-wrapper">
                <div className="admin-portal-text">Provider Dashboard</div>
              </div>
            </div>
            {menuItems.map((item, index) => (
              <div key={index} className="provider-menu-items-wrapper">
                {item.subMenu ? (
                  <SubMenuSideBar
                    navSubMenu={item}
                    collapsed={collapsed}
                    toggleCollapse={toggleCollapse}
                    handleIfNoPath={handleIfNoPath}
                    setIsSidebarClick={setIsSidebarClick}
                    activeNavbar={activeNavbar}
                    setClickedActiveItem={setClickedActiveItem}
                    openDropdown={openDropdown}
                    selectedPath={selectedPath}
                  />
                ) : (
                  <NavItem>
                    <NavLink
                      className={() =>
                        `menu-item ${selectedPath === item.path ? "active" : ""}`
                      }
                      to={item.path}
                      onClick={() => handleMenuClick(item)}
                    >
                      <img
                        src={item.icon}
                        alt={item.label}
                        className="menu-icon"
                      />
                      <span>{item.label}</span>
                      {item.path === routes.PROVIDER_LEADS &&
                        showLeadIndicator && <span className="red-dot" />}
                    </NavLink>
                  </NavItem>
                )}
              </div>
            ))}
          </div>
          <div className="sidebar-footer-provider">
            {footerItems.map((item, index) => (
              <NavItem key={index} className="footer-item">
                <NavLink
                  className={({ isActive }) =>
                    `footer-button ${
                      isActive || selectedPath === item.path ? "selected" : ""
                    }`
                  }
                  to={item.path}
                  onClick={() => handleMenuClick(item)}
                >
                  <img
                    src={item.icon}
                    alt={item.label}
                    className="footer-icon"
                  />
                  <span className="footer-label">{item.label}</span>
                </NavLink>
              </NavItem>
            ))}
          </div>
        </div>

        {alertMessage?.open && (
          <AlertComponent
            message={alertMessage?.message}
            type="success"
            open={alertMessage?.open}
            onClose={() => setAlertMessage({ open: false })}
          />
        )}
      </div>
    </>
  );
};

export default Sidebar;
